import React from 'react';

import { Skeleton } from '@shared/ui';

import cls from './EquipmentBoardSkeleton.module.css';

const SKELETON_COLUMNS = Array.from({ length: 4 }, (_, index) => index);

export const EquipmentBoardSkeleton = () => (
    <div className={cls.EquipmentBoardSkeleton}>
        {SKELETON_COLUMNS.map((column) => (
            <Skeleton
                key={column}
                width={240}
                height="100%"
                border="3px"
                classes={cls.columnSkeleton}
            />
        ))}
        <Skeleton width={240} height={28} border="3px" classes={cls.addWarehouseSkeleton} />
    </div>
);
